<template>
  <div class="sessions">
    <ag-table
      :data-source-api="getAllSessions"
      :grid-options="gridOptions"
      :permissions="permissions"
      :rtl="false"
      :is-entities-response="false"
      v-on="dynamicEvents"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from "../volunteer-repositories/volunteerRepositoryFactory";
import AgTable from "../../shared/shared-components/ag-grid/AgTableServerSide.vue";
import AgTableBtnCell from "../../shared/shared-components/ag-grid/AgTableBtnCell";
import AgButton from "@/app/shared/shared-components/ag-grid/AgButton";
import utilities from "@/app/shared/utilities/index";

const tasksRepo = RepositoryFactory.get("tasksRepository");

export default {
  name: "TaskSessionsManagement",
  components: {
    AgTable,
    // eslint-disable-next-line vue/no-unused-components
    AgButton,
    // eslint-disable-next-line vue/no-unused-components
    AgTableBtnCell,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      status: {
        ACTIVE: "نشطة",
        CANCELLED: "ملغية",
        COMPLETED: "مكتملة",
      },
      permissions: {
        edit: "tasks_management",
        delete: "tasks_management",
        "view-users": "volunteer_manage",
      },
      isArchived: false,
    };
  },
  computed: {
    dynamicEvents() {
      const events = {
        emitExportToExcel: this.exportToExcel,
      };

      if (!this.isArchived) {
        events.emitAddNewRecord = () => {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.$router.push({ path: `/volunteers/tasks/${this.$route.params.id}/edit` });
        };
      }

      return events;
    },
  },
  methods: {
    createColDefs() {
      let self = this;
      const columns = [
        {
          headerName: "معرف الفرصة",
          field: "taskId",
          sortable: true,
          width: 200,
        },
        {
          headerName: "معرف الجلسة",
          field: "id",
          sortable: true,
          width: 200,
        },
        {
          headerName: "عدد المتطوعين",
          field: "maxSeats",
          filter: "agNumberColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "تاريخ الجلسة",
          field: "date",
          filter: "agDateColumnFilter",
          width: 200,
          sortable: false,
          valueGetter: function getObject(data) {
            return data.data.date ? utilities.formatDate(data.data.date, "yyyy-MM-DD") : '-';
          },
        },
        {
          headerName: "من وقت",
          field: "startAt",
          width: 200,
          sortable: false,
          valueGetter: function getObject(data) {
            return data.data.startAt || '-';
          },
        },
        {
          headerName: "إلى وقت",
          field: "endAt",
          width: 200,
          sortable: false,
          valueGetter: function getObject(data) {
            return data.data.endAt || '-';
          },
        },
        {
          headerName: "الحالة",
          field: "status",
          width: 210,
          sortable: false,
          valueGetter: function getObject(params) {
            return self.status[params.data.status] || "-";
          },
          filter: "agSetColumnFilter",
          filterParams: {
            values: Object.keys(self.status),
            valueFormatter: (params) =>
              self.status[params.value] || params.value,
          },
        },
        {
          headerName: "العدد المتبقي",
          field: "availableSeats",
          width: 210,
          sortable: true,
          valueGetter: function getObject(params) {
            return params.data.availableSeats == 0
              ? "اكتمل العدد"
              : params.data.availableSeats;
          },
        },
      ];

      if (!self.isArchived) {
        columns.push({
          headerName: "إغلاق الجلسة",
          field: "volunteeringFieldId",
          width: 210,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: (params) => {
            return {
              size: "small",
              color: "primary",
              name: "إغلاق الجلسة",
              type: "gradient",
              disabled: !["ACTIVE"].includes(params.data.status),
              click(session) {
                self.$router.push({
                  path: `/volunteers/tasks/${session.taskId}/sessions/${session.id}/close`,
                });
              },
            };
          },
        });
      }

      const actions = self.isArchived ? ["view-users"] : ["edit", "delete", "view-users"];

      columns.push({
        headerName: "الإجراءات",
        cellRendererFramework: AgTableBtnCell,
        sortable: false,
        valueGetter: function getObject(params) {
          return params.data;
        },
        cellRendererParams: {
          editRecord: function (session) {
            self.$router.push({
              path: `/volunteers/tasks/${session.taskId}/edit`,
            });
          },
          viewUsersRecord: function (session) {
            self.$router.push({
              path: `/volunteers/tasks/${session.taskId}/sessions/${session.id}/applied`,
            });
          },
          deleteRecord: function (session) {
            self.deleteTaskSession(session);
          },
          actions: actions,
          permissions: self.permissions,
        },
      });

      return columns;
    },
    async deleteTaskSession(session) {
      await tasksRepo.deleteTaskSession(session.id);
      this.$vs.notify({
        title: 'نجاح',
        color: 'success',
        text: 'تم حذف الجلسة بنجاح.',
      });
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    async getAllSessions(query) {
      return await tasksRepo.fetchTaskSessions(this.$route.params.id, `${query}${query ? "&" : "?"}sort=createdAt,DESC`);
    },
    async exportToExcel() {
      const query = `?taskId=${this.$route.params.id}`;
      await tasksRepo.exportTaskSessionsAppliedVolunteers(query);
    },
  },
  created() {
    this.isArchived = this.$route.query.archived === 'true';
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
};
</script>
